import React from "react";
import Box from "@mui/material/Box";
import Hat from "@/assets/icons/app/hl-top-hat.gif";
import Image from "@/components/image";
import { Typography } from "@mui/material";
// ----------------------------------------------------------------------

export default function SplashScreen() {
  return (
    <Box
      sx={{
        alignItems: "center",
        textAlign: "center",
        mt: "30vh",
      }}
    >
      <Image
        src={Hat}
        sx={{
          width: "100px",
          height: "100px",
        }}
      ></Image>
      <Typography variant="h3">Loading</Typography>
      <Typography
        variant="body1"
        sx={{
          mt: 2,
        }}
      >
        Hold tight, we&apos;re setting things up...
      </Typography>
    </Box>
  );
}
